import $ from 'jquery';

/**
 * Bootstrap
 * @link https://getbootstrap.com/
 */
// import {
//   Tooltip,
//   Toast
// } from 'bootstrap';

/**
 * EndLessRiver
 * @link  https://www.npmjs.com/package/endlessRiver
 */
import '../../node_modules/endlessRiver/endless-river.js';

/**
 * Pushy
 * @link https://github.com/christophery/pushy/blob/master/README.md
 */
import '../../node_modules/@cmyee/pushy/js/pushy.js';

/**
 * Lightgallery
 * @link https://sachinchoolur.github.io/lightgallery.js/docs/
 */
import '../../node_modules/lightgallery/dist/js/lightgallery.min.js';

/**
 * Swiper.js
 * @link https://swiperjs.com/swiper-api
 */
import Swiper from '../../node_modules/swiper/swiper-bundle.min.js';

/**
 * Masonry
 * @link https://masonry.desandro.com/
 */
// import 'masonry-layout';

/**
 * MHead
 * @link https://github.com/FrDH/mhead-js#readme
 */
// import 'mhead-js';

/**
 * Zebra Pin
 * @link https://stefangabos.github.io/Zebra_Pin/
 */
// import '../../node_modules/zebra_pin/dist/zebra_pin.min.js';

(function(red) {

  red(window.jQuery, window, document);

}(function($, window, document) {

  var templateFunctions = {

    init: function() {
      templateFunctions.endlessRiver();
      templateFunctions.lightgallery();
      templateFunctions.youtubeIframeApi();
      templateFunctions.swiper();
      templateFunctions.facebookApi();
      templateFunctions.twitterApi();
      templateFunctions.instagramApi();
    },

    endlessRiver: function() {
      $("#newsticker").endlessRiver({
        speed: 75
      });
    },

    lightgallery: function() {
      $(".gallery").lightGallery({
        closable: true,
        selector: '.gallery-item',
        download: false,
        counter: false
      });
    },

    youtubeIframeApi: function() {

      if ($(".yt-player").length) {

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


        window.onYouTubeIframeAPIReady = function() {

          var playerContainers = document.getElementsByClassName('yt-player-wrap');
          var players = [];

          for (var i = 0; i < playerContainers.length; i++) {

            var element = playerContainers[i].getElementsByClassName('yt-player')[0];

            if (element) {
              var id = element.getAttribute('data-id');
              var player = new YT.Player(element, {
                height: '360',
                width: '640',
                videoId: id,
                playerVars: {
                  autoplay: 0,
                  cc_load_policy: 0,
                  color: 'red',
                  controls: 1,
                  enablejsapi: 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  origin: window.location.hostname,
                  rel: 0,
                  showinfo: 0,
                }
              });
              players.push(player);
            }
          }

          if ($(".swiper-video-thumbs").length) {
            var swiperVideoThumbs = new Swiper('.swiper-video-thumbs', {
              spaceBetween: 4,
              slidesPerView: 3,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
            });
          }

          if ($(".swiper-video").length) {
            var swiperVideo = new Swiper('.swiper-video', {
              effect: 'fade',
              speed: 400,
              spaceBetween: 0,
              navigation: {
                nextEl: '.swiper-video-button-next',
                prevEl: '.swiper-video-button-prev',
              },
              thumbs: {
                swiper: swiperVideoThumbs
              },
              on: {
                slideChange: function() {
                  if (players[swiperVideo.previousIndex]) {
                    players[swiperVideo.previousIndex].pauseVideo();
                  }
                  // if (players[swiperVideo.activeIndex]) {
                  //     players[swiperVideo.activeIndex].playVideo();
                  // }
                }
              }
            });
          }

        };
      }
    },

    swiper: function() {

      if ($(".swiper-photo-thumbs").length) {
        var swiperPhotoThumbs = new Swiper('.swiper-photo-thumbs', {
          spaceBetween: 4,
          slidesPerView: 3,
          freeMode: true
        });
      }

      if ($(".swiper-photo").length) {

        var swiperPhoto = new Swiper('.swiper-photo', {
          effect: 'fade',
          speed: 400,
          spaceBetween: 0,
          navigation: {
            nextEl: '.swiper-photo-button-next',
            prevEl: '.swiper-photo-button-prev',
          },
          thumbs: {
            swiper: swiperPhotoThumbs
          }
        });
      }

      if ($(".swiper-advertising").length) {
        var swiperAds = new Swiper('.swiper-advertising', {
          effect: 'fade',
          autoplay: {
            delay: 8000,
          },
          navigation: {
            nextEl: '.swiper-advertising-button-next',
            prevEl: '.swiper-advertising-button-prev',
          },
        });
      }

      if ($(".swiper-articles").length) {
        var swiperArticles = new Swiper('.swiper-articles', {
          slidesPerView: 1,
          spaceBetween: 4,
          preloadImages: false,
          lazy: true,
          breakpoints: {
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
              },
              1400: {
                slidesPerView: 5,
              },
          },
          navigation: {
            nextEl: '.swiper-articles-button-next',
            prevEl: '.swiper-articles-button-prev',
          },
          pagination: {
            el: '.swiper-articles-pagination',
            type: 'bullets',
          },
        });
      }

    },

    facebookApi: function() {

      if ($(".fb-video").length || $("#fb-post").length || $(".fb-comments").length) {
        window.fbAsyncInit = function() {
            FB.init({
                appId: '2872390659686024',
                autoLogAppEvents: true,
                cookie: true,
                xfbml: true,
                version: 'v9.0'
            });

            FB.AppEvents.logPageView();
        };

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/es_LA/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
      }
    },

    twitterApi: function() {
      if ($(".tw-post").length) {
        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };

            return t;
        }(document, "script", "twitter-wjs"));
      }
    },

    instagramApi: function() {
      if ($(".in-post")) {
        var tag = document.createElement('script');
        tag.src = "//www.instagram.com/static/bundles/es6/EmbedSDK.js/58b07fec4121.js";

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    },
  };

  $(function() {
    templateFunctions.init();
  });

}));
